module.exports = ".textSymbolCon {\n  height: 100%;\n  width: 100%;\n  color: rgb(128, 127, 131);\n  overflow: hidden;\n}\n\n.textSymbolHeaderCon {\n  border-bottom: 1px solid lightgray\n}\n\n.SymbolDivCon {\n  height: 30px;\n  width: 40px;\n  border: 1px solid #636267;\n  float: left;\n  margin: 5px;\n  color: #636363;\n  cursor: pointer;\n}\n\n.loadSymbolCon {\n  margin: 12px 12px 0px 25px;\n  height: 236px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/text/symbol/symbol.component.css
// module id = ./src/app/bookShared/bookeditoption/bookEditOptionPopups/text/symbol/symbol.component.css
// module chunks = main